import mockAxios, { AxiosResponse } from 'axios';
import { IItemTagServiceMock } from './item-tag.mock.types';

export const mockItemTagService = (): IItemTagServiceMock => ({
  fetchTags: jest.fn(),
  fetchTag: jest.fn(),
  createTag: jest.fn(),
  updateTag: jest.fn(),
  deleteTag: jest.fn()
});

export const mockItemTagAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
